import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const root = css`
  margin-bottom: ${spacing.md}px;

  h2 {
    margin: 0 0 ${spacing.md}px;
    ${responsiveText.HEADING.XS};
  }

  h3 {
    margin: 0;
    padding: ${spacing.md}px 0;
    ${responsiveText.BODY.MD};
  }
`;

export const questions = css`
  margin: 0;
  border-radius: ${spacing.md}px;
  border: 1px solid var(--neutral-black-10);
  padding: ${spacing.base}px ${spacing.md}px;
  list-style: none;

  li:not(:last-child) {
    border-bottom: 1px solid var(--neutral-black-10);
  }
`;

export const answer = css`
  padding-bottom: ${spacing.md}px;
  ${responsiveText.BODY.MD};
`;
